import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../App';

const NAV_ITEMS = [
  { path: '/dashboard', label: 'Dashboard', icon: '◆' },
  { path: '/mapping', label: 'Mappings', icon: '⇄' },
  { path: '/gatekeeper', label: 'Approvals', icon: '✚', badgeKey: 'pendingApprovals' },
  { path: '/logs', label: 'Sync Logs', icon: '≡' },
  { path: '/onboarding', label: 'Setup Wizard', icon: '⚙' },
  { path: '/profile', label: 'Profile', icon: '◉' },
];

export default function Sidebar({ pendingApprovals = 0 }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem('sidebar_collapsed') === 'true'; }
    catch { return false; }
  });

  const toggle = () => {
    setCollapsed(prev => {
      const next = !prev;
      try { localStorage.setItem('sidebar_collapsed', String(next)); } catch {}
      return next;
    });
  };

  const width = collapsed ? 56 : 200;

  return (
    <div
      className="app-sidebar"
      style={{
        width,
        minWidth: width,
        maxWidth: width,
        transition: 'width 0.2s ease, min-width 0.2s ease, max-width 0.2s ease',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
      }}
    >
      {/* Top bar */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: collapsed ? 0 : 10,
        padding: '0 0 16px 0',
        minHeight: 36,
      }}>
        <button
          onClick={toggle}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--muted)',
            cursor: 'pointer',
            fontSize: 18,
            padding: '4px 6px',
            borderRadius: 6,
            flexShrink: 0,
            lineHeight: 1,
          }}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          ☰
        </button>
        {!collapsed && (
          <span style={{ fontWeight: 900, fontSize: 15, color: 'var(--text)', whiteSpace: 'nowrap' }}>
            SyncBridge
          </span>
        )}
      </div>

      <div className="divider" style={{ marginBottom: 8 }} />

      {/* Nav items */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
        {NAV_ITEMS.map(item => (
          <a
            key={item.path}
            className={location.pathname === item.path ? 'active' : ''}
            onClick={() => navigate(item.path)}
            title={collapsed ? item.label : undefined}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: collapsed ? 'center' : 'flex-start',
              gap: collapsed ? 0 : 10,
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: 15, flexShrink: 0 }}>{item.icon}</span>
            {!collapsed && (
              <>
                {item.label}
                {item.badgeKey === 'pendingApprovals' && pendingApprovals > 0 && (
                  <span className="badge" style={{ marginLeft: 'auto', padding: '2px 7px' }}>
                    {pendingApprovals}
                  </span>
                )}
              </>
            )}
          </a>
        ))}
      </div>

      {/* Logout */}
      <div style={{ paddingTop: 16 }}>
        <a
          onClick={logout}
          title={collapsed ? 'Logout' : undefined}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: collapsed ? 'center' : 'flex-start',
            gap: collapsed ? 0 : 10,
            cursor: 'pointer',
          }}
        >
          <span style={{ flexShrink: 0 }}>↩</span>
          {!collapsed && 'Logout'}
        </a>
      </div>
    </div>
  );
}
